import React from 'react'
import { Route, Routes, Navigate } from "react-router-dom";
import AuthenticateRoute from './middleware/AuthenticateRoute';
import LoginChart from './pages/others/LoginChart';

const Login = React.lazy(() => import('./pages/auth/Login'));
const Dashboard = React.lazy(() => import('./pages/dashboard/Dashboard'));
const Docspedia = React.lazy(() => import('./pages/others/DocsPedia'));
const AddRBDM = React.lazy(() => import('./pages/others/AddRBDM'));
const Reports = React.lazy(() => import('./pages/others/Reports'));
const LeadGenerate = React.lazy(() => import('./pages/rtm/LeadGenerate'));
const LeadOpen = React.lazy(() => import('./pages/rtm/LeadOpen'));
const RenewalConf = React.lazy(() => import('./pages/rtm/RenewalConf'));
const RtmEscalation = React.lazy(() => import('./pages/rtm/RtmEscalation'));
const RtmSearch = React.lazy(() => import('./pages/rtm/RtmSearchFilter'));
const Activity = React.lazy(() => import('./pages/activity/Activity'));
const ActivityTracker = React.lazy(() => import('./pages/activity/ActivityTracker'));
const ActivityTrend = React.lazy(() => import('./pages/activity/ActivityTrend'));
const AddMeeting = React.lazy(() => import('./pages/activity/AddMeeting'));

const  RtmSearchList = React.lazy(() => import('./pages/rtm/RtmSearchList'));
const  ActivityPlanMaster = React.lazy(() => import('./pages/activity/ActivityPlanMaster'));
const  AddActivityPlan = React.lazy(() => import('./pages/activity/AddActivityPlan'));
const  DashboardList = React.lazy(() => import('./pages/dashboard/DashboardList'));
const  ViewActivityTracker = React.lazy(() => import('./components/activity/ViewActivityTracker'));
const  LiveTracking = React.lazy(() => import('./pages/others/LiveTracking'));
const  AtWork = React.lazy(() => import('./pages/others/AtWork'));
const  NotLoggedIn = React.lazy(() => import('./pages/others/NotLoggedIn'));
const  UpdateActivityPlan = React.lazy(() => import('./pages/activity/UpdateActivityPlan'));
const  OwnActivity = React.lazy(() => import('./pages/others/OwnActivity'));
const  CapacityUtilization = React.lazy(() => import('./pages/dashboard/CapacityUtilization'));
const  BirthdayWorkAniversary = React.lazy(() => import('./pages/others/BirthdayWorkAniversary'));
const  RbdmThDashboard = React.lazy(() => import('./pages/others/RbdmThDashboard'));
const  AddEmployeeMsg = React.lazy(() => import('./pages/others/AddEmployeeMsg'));
const  TravelLog = React.lazy(() => import('./pages/others/TravelLog'));
const  DensityPenetration = React.lazy(() => import('./pages/others/DensityPenetration'));
const  MapForWorkScreen = React.lazy(() => import('./pages/others/MapForWorkScreen'));
const  EmployeeMsgList = React.lazy(() => import('./pages/others/EmployeeMsgList'));
const  OpenProspective = React.lazy(() => import('./pages/activity/OpenProspective'));
const  ViewRemapEmployee = React.lazy(() => import('./pages/activity/ViewRemapEmployee'));
const  PageNotFound = React.lazy(() => import('./pages/404Page'));
const  PrivacyPolicy = React.lazy(() => import('./pages/others/PrivacyPolicy'));

const AppRoute = () => {
  return (
    <Routes>
      {/* AUTH ROUTE */}
      <Route path="/login" element={
            <React.Suspense fallback={<>...</>}>
              <Login />
            </React.Suspense>
          } />

      {/* HOME ROUTES */}
      <Route
        path="/"
        element={<Navigate to="/dashboard" replace />}
    />
      <Route path="/dashboard" element={
          <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="DASHBOARD">
            <Dashboard/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />

  <Route path="/dashboard/capacity_utilization" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="DASHBOARD">
            <CapacityUtilization/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />  

      <Route path="/dashboard/:listName" element={
          <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="DASHBOARD">
            <DashboardList/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />



      {/* RTM ROUTES */}
      <Route path="/renewal-tracking" element={
         <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RTM">
            <RenewalConf/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />
      <Route path="/renewal/lead-generate" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RTM">
            <LeadGenerate/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />
      <Route path="/renewal/lead-open" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RTM">
            <LeadOpen/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />
      <Route path="/renewal/escalation" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RTM">
            <RtmEscalation/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />

      <Route path="/renewal/search" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RTM">
            <RtmSearch/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />

    <Route path="/renewal/search/list" element={
       <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RTM">
            <RtmSearchList/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />

      {/* ACTIVITY ROUTES */}
      <Route path="/activity" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <Activity/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />

      <Route path="/activity/view-remaped" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <ViewRemapEmployee/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />

       <Route path="/activity/tracker" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <ActivityTracker/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

    <Route path="/activity/open-prospective" element={
      <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <OpenProspective/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />  

       
      <Route path="/activity/viewActivityTracker/:id" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <ViewActivityTracker/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />  

      <Route path="/activity/add-meeting" element={
        //ADMEETING
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <AddMeeting/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />      
       <Route path="/activity-trend" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <ActivityTrend/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/activity-planmaster" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <ActivityPlanMaster/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/activity-planmaster/add" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <AddActivityPlan/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/activity-planmaster/edit/:id" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <UpdateActivityPlan/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />    


      {/* OTHER ROUTES */}

      <Route path="/docs-pedia" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <Docspedia/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/rbdm-activity" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RBDMACTIVITY">
            <AddRBDM/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/reports" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <Reports/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/live-tracking" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="LIVETRACKING">
            <LiveTracking/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/at-work" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="LIVETRACKING">
            <AtWork/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      /> 

      <Route path="/not-loggedin" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="LIVETRACKING">
            <NotLoggedIn/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />  

      <Route path="/own-activity-detail" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="ACTIVITY">
            <OwnActivity/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />    

      <Route path="/birthday-work-aniversary" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="DASHBOARD">
            <BirthdayWorkAniversary/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />    

      <Route path="/rbdm-th-dashbaord" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="RBDMACTIVITY">
            <RbdmThDashboard/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />  

     <Route path="/add-employee-msg" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <AddEmployeeMsg/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />  

      
    <Route path="/employee-msg-list" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <EmployeeMsgList/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />     

    <Route path="/travel-log" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <TravelLog/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />   

      <Route path="/density-penetration" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <DensityPenetration/>
          </AuthenticateRoute>
          </React.Suspense>
        }
      />   

      <Route path="/mapView" element={
        <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="">
            <MapForWorkScreen />
          </AuthenticateRoute>
          </React.Suspense>
        }
      />  

    <Route path="/privacy-policy" 
        element={ <React.Suspense fallback={<>...</>}>
            <PrivacyPolicy />
            </React.Suspense> 
    } />

    <Route
        path="/showLoginChart"
        element={
          <React.Suspense fallback={<>...</>}>
          <AuthenticateRoute roles="LOGINDATA">
          <LoginChart/>
          </AuthenticateRoute>
          </React.Suspense>
       }
    />


    <Route
        path="*"
        element={
          <React.Suspense fallback={<>...</>}>
            <PageNotFound/>
          </React.Suspense>
      }
    />
      
    </Routes>
  )
}

export default AppRoute